import { render, staticRenderFns } from "./Table-card.vue?vue&type=template&id=d4c864e4&scoped=true&"
import script from "./Table-card.vue?vue&type=script&lang=js&"
export * from "./Table-card.vue?vue&type=script&lang=js&"
import style0 from "./Table-card.vue?vue&type=style&index=0&id=d4c864e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c864e4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/build/repo/components/Loading.vue').default})
